import { BrowseIcon, LockIcon } from 'components/Icons';
import React, { useRef } from 'react';
import './styles.scss';
const rootClassName = 'flag-is-public';

interface IFlagIsPublic {
  disabledPublic?: boolean;
  disabledPrivate?: boolean;
  setPublic?: any;
  setPrivate?: any;
}

export const FlagIsPublic: React.FC<IFlagIsPublic> = ({ ...props }) => {
  const publicRef = useRef() as any;
  const privateRef = useRef() as any;

  return (
    <div className={rootClassName}>
      <button
        ref={publicRef}
        className={`${rootClassName}-pergunta-publica`}
        onClick={(e: any) => {
          e.preventDefault();
          props.setPublic();
        }}
        disabled={props.disabledPublic}
        tabIndex={props.disabledPublic ? -1 : 0}
        aria-disabled={props.disabledPublic ? 'true' : 'false'}
      >
        <BrowseIcon />
      </button>
      <button
        ref={privateRef}
        className={`${rootClassName}-pergunta-privada`}
        onClick={(e: any) => {
          e.preventDefault();
          props.setPrivate();
        }}
        disabled={props.disabledPrivate}
        tabIndex={props.disabledPrivate ? -1 : 0}
        aria-disabled={props.disabledPrivate ? 'true' : 'false'}
      >
        <LockIcon />
      </button>
    </div>
  );
};
